module.exports = __webpack_public_path__ + "img/CrediCore1.6b70b532.png";